// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"544":"e52c2e81","985":"6de36e97"}[chunkId] + ".chunk.css";
};